import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { NotificationActions } from '@ninety/platform/state/app-global/notifications/notification.actions';
import { LoggingActions } from '@ninety/platform/state/app-logging/app-logging.actions';
import { DIAGNOSTIC_LOGGER, DiagnosticLogger, OPERATION_ERROR_NOTIFIER, OperationErrorNotifier } from '@ninety/ui/core';

/**
 * Binds the tokens consumed by `HierarchyTreeComponentStore` in `@ninety/ui/core` to their
 * `platform/state` dispatches: diagnostic logging (`LoggingActions`) and the failed-operation toast
 * (`NotificationActions.notifyError`). The store stays free of any `@ninety/platform/state` dependency
 * so the tree can be packaged in the public API; this composition-root wiring is the single place that
 * depends on both the tokens and `platform/state`. (DEV-26530 6b)
 *
 * The tree's spinner (`PRIMARY_SPINNER_CONTROL`) is already bound by `UPLOAD_DIALOG_PROVIDERS`
 * (Part 8b), so it is not re-bound here.
 */
export const TREE_PROVIDERS: Provider[] = [
  {
    provide: DIAGNOSTIC_LOGGER,
    useFactory: (store: Store): DiagnosticLogger => ({
      debug: log => store.dispatch(LoggingActions.debug({ log })),
      warn: log => store.dispatch(LoggingActions.warn({ log })),
    }),
    deps: [Store],
  },
  {
    provide: OPERATION_ERROR_NOTIFIER,
    useFactory:
      (store: Store): OperationErrorNotifier =>
      (message, error) =>
        store.dispatch(NotificationActions.notifyError({ message, error })),
    deps: [Store],
  },
];
